import { render, staticRenderFns } from "./FilesUpload.vue?vue&type=template&id=53522e49&scoped=true&"
import script from "./FilesUpload.vue?vue&type=script&lang=js&"
export * from "./FilesUpload.vue?vue&type=script&lang=js&"
import style0 from "./FilesUpload.vue?vue&type=style&index=0&id=53522e49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53522e49",
  null
  
)

component.options.__file = "FilesUpload.vue"
export default component.exports